export default "__VITE_ASSET__79d5ebd4__"